<template>
  <button
      @click="toggleTheme"
      :class="btnClass"
      :title="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
  >
    <svg v-if="isDark" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clip-rule="evenodd" />
    </svg>

    <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
      <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
    </svg>

    <span v-if="menuItem" class="text-sm">{{ isDark ? 'Light Mode' : 'Dark Mode' }}</span>
  </button>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  name: 'ThemeToggle',
  props: {
    menuItem: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    btnClass() {
      if (this.menuItem) {
        return 'flex items-center gap-3 w-full text-left px-4 py-2.5 text-sm hover:bg-background-lighter text-text-primary transition-colors';
      }
      return 'p-2 rounded-md hover:bg-background-lighter';
    }
  },
  setup() {
    const isDark = ref(false);

    // Function to toggle theme
    const toggleTheme = () => {
      isDark.value = !isDark.value;

      if (isDark.value) {
        document.documentElement.classList.add('dark');
        localStorage.setItem('theme', 'dark');
      } else {
        document.documentElement.classList.remove('dark');
        localStorage.setItem('theme', 'light');
      }
    };

    // Initialize theme based on local storage
    onMounted(() => {
      // Check for saved theme preference
      const savedTheme = localStorage.getItem('theme');

      if (savedTheme === 'dark') {
        isDark.value = true;
        document.documentElement.classList.add('dark');
      } else {
        // Default to light mode
        isDark.value = false;
        document.documentElement.classList.remove('dark');
      }
    });

    return {
      isDark,
      toggleTheme
    };
  }
}
</script>